var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"color":"light-bg"}},[_c('lottie-vue-player',{attrs:{"src":_vm.loading_animation,"autoplay":true,"loop":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }